/* eslint-disable newline-per-chained-call */
import SelectDays from "@/components/selectDays/selectDays.vue";
import CreateEditOpenDays from "@/components/createEditOpenDays/createEditOpenDays.vue";
import ConfirmChangeDatesModal from "@/components/modal/confirmChangeDatesModal.vue";
import { createNamespacedHelpers } from "vuex";
import moment from "moment";

const { mapActions: userActions } = createNamespacedHelpers("user");

export default {
	components: {
		ConfirmChangeDatesModal,
		SelectDays,
		CreateEditOpenDays,
	},

	props: {
		date: {
			type: Object,
			required: true,
		},
	},

	data() {
		return {
			isEdit: false,
			showDeletePrompt: false,
		};
	},

	methods: {
		onConfirmDelete,

		...userActions(["deleteClosedDay"]),
	},

	computed: { isCurrent },
};

function onConfirmDelete() {
	this.deleteClosedDay(this.date);
}

// checks if it is the current open closed day setting
function isCurrent() {
	const today = moment().startOf("day");

	return (
		moment(this.date.start_date).startOf("day").isSameOrBefore(today) &&
		(!this.date.end_date || moment(this.date.end_date).startOf("day").isSameOrAfter(today))
	);
}
